// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

button {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  cursor: pointer;
}
.logoContainer{
  background-color: rgb(255, 255, 255);
  width: -moz-fit-content;
  width: fit-content;
  /* height: 100px; */
  border-bottom-right-radius: 60%;
  padding: 5px;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  box-shadow: -7px -4px 16px 0px #4c4c4c;
}

.logoImg {
  width: 100px;
  margin: 10px;

}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;EAC5D,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,YAAY;;AAEd","sourcesContent":[".App {\n  text-align: center;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\nbutton {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  cursor: pointer;\n}\n.logoContainer{\n  background-color: rgb(255, 255, 255);\n  width: fit-content;\n  /* height: 100px; */\n  border-bottom-right-radius: 60%;\n  padding: 5px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  box-shadow: -7px -4px 16px 0px #4c4c4c;\n}\n\n.logoImg {\n  width: 100px;\n  margin: 10px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
